/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import { InsuranceOffer } from 'types/Product';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement, Radio, RadioGroup } from '@tvg/fuse-design';

const InsuranceRadio = styled(Radio)`
  label {
    font-size: var(--font-size-m1);
  }
`;

interface InsuranceSelectorProps {
  options?: InsuranceOffer[] | null;
  selectedInsurance?: InsuranceOffer | string | null;
  handleSelectedInsurance: (option: InsuranceOffer | null) => void;
  handleNoInsuranceSelect: () => void;
  type?: string;
  showNoInsuranceRadio?: boolean;
  skuId: string;
}

const StyledTypography = styled(TypographyElement)`
  margin-bottom: var(--spacing-space16);
`;

export function InsuranceSelector({
  options,
  handleSelectedInsurance,
  handleNoInsuranceSelect,
  selectedInsurance,
  type = '',
  showNoInsuranceRadio = true,
  skuId,
}: InsuranceSelectorProps) {
  const getChecked = (option: InsuranceOffer) => {
    if (typeof selectedInsurance === 'object' && !Object.is(selectedInsurance, null) && selectedInsurance?.offer) {
      return option.offer.productId === selectedInsurance?.offer.productId;
    }

    return false;
  };

  return options ? (
    <div>
      <StyledTypography color="var(--color-global-black)" size="1" tag="p">
        Choose an Insurance option
      </StyledTypography>
      {showNoInsuranceRadio ? (
        <RadioGroup dataTestId="insurance-radio-group" groupName={`insurance-radio-group${type}`}>
          {options.map((option) => (
            <InsuranceRadio
              dataTestId={`insurance-radio-button-${option.offer.termDescription
                .toLocaleLowerCase()
                .split(' ')
                .join('-')}${type}`}
              clickCallback={() => {
                handleSelectedInsurance(option);
              }}
              radioLabel={`${option.offer.termDescription} £${option.offer.sellingPrice}${
                option?.offer.termDescription === 'Monthly Insurance' ? ' a month' : ''
              }`}
              radioName={option.offer.termDescription}
              key={`${option.offer.productId}${type}${option.offer.sellingPrice}${skuId}`}
              checked={getChecked(option)}
            />
          ))}
          <InsuranceRadio
            dataTestId={`insurance-radio-button-no-insurance${type}`}
            clickCallback={handleNoInsuranceSelect}
            radioLabel="No Insurance"
            radioName="No Insurance"
            key="no-insurance-radio"
            checked={selectedInsurance === 'No insurance'}
          />
        </RadioGroup>
      ) : (
        <RadioGroup dataTestId="insurance-radio-group" groupName={`insurance-radio-group${type}`}>
          {options.map((option) => (
            <InsuranceRadio
              dataTestId={`insurance-radio-button-${option.offer.termDescription
                .toLocaleLowerCase()
                .split(' ')
                .join('-')}${type}`}
              clickCallback={() => {
                handleSelectedInsurance(option);
              }}
              radioLabel={`${option.offer.termDescription} £${option.offer.sellingPrice}${
                option?.offer.termDescription === 'Monthly Insurance' ? ' a month' : ''
              }`}
              radioName={option.offer.termDescription}
              key={`${option.offer.productId}${type}${option.offer.sellingPrice}${skuId}`}
              checked={getChecked(option)}
            />
          ))}
        </RadioGroup>
      )}
    </div>
  ) : null;
}

export default { InsuranceSelector };
